import IwNormaliser from './iwNormaliser/';
import IwIntlProvider from './iwIntlProvider/IwIntlProvider';
import { IwLogger } from './iwLogger/IwLogger';
import IwProvider from './iwProvider/IwProvider';
import IwRouter from './iwRouter';
import IwSiteContext from './iwSiteContext/IwSiteContext';
import { IwQueryClientProvider } from './iwQueryClient/IwQueryClientProvider';
import MyAccount from './myAccount';

const App = () => {
    return (
        <IwQueryClientProvider>
            <IwNormaliser>
                <IwLogger>
                    <IwProvider>
                        <IwSiteContext>
                            <IwIntlProvider>
                                <IwRouter disableFirstRouterChange={true}>
                                    <MyAccount />
                                </IwRouter>
                            </IwIntlProvider>
                        </IwSiteContext>
                    </IwProvider>
                </IwLogger>
            </IwNormaliser>
        </IwQueryClientProvider>
    );
};

// eslint-disable-next-line import/no-default-export
export default App;
